import { FC } from 'react';
import styled from 'styled-components';
import { SvgIconProps } from 'ui/icons';
import { spacing, colors, subtitle1, body1, heading4 } from 'ui/theme';

type StyledProps = {
  noSpacing?: boolean;
};

export const EmptyStateContainer = styled.div<StyledProps>`
  background: ${colors.grey1};
  text-align: center;
  padding: ${spacing.x3};
  margin-top: ${({ noSpacing }) => (noSpacing ? 0 : spacing.x8)};
`;

export const EmptyStateTitle = styled.div<StyledProps>`
  ${subtitle1}
  ${heading4}
  margin-top: ${({ noSpacing }) => (noSpacing ? 0 : spacing.quarter)};
`;

export const EmptyStateSubtitle = styled.div<StyledProps>`
  ${body1}
  color: ${colors.textSecondary};
  margin-top: ${({ noSpacing }) => (noSpacing ? 0 : spacing.quarter)};
`;

type Props = {
  Icon: (props: SvgIconProps) => JSX.Element;
  title: string;
  subtitle: string;
  noSpacing?: boolean;
};

export const NoDataMessage: FC<React.PropsWithChildren<Props>> = ({
  Icon,
  title,
  subtitle,
  noSpacing = false,
}) => (
  <EmptyStateContainer noSpacing={noSpacing}>
    <Icon />
    <EmptyStateTitle data-test="empty-state-title" noSpacing={noSpacing}>
      {title}
    </EmptyStateTitle>
    <EmptyStateSubtitle data-test="empty-state-subtitle" noSpacing={noSpacing}>
      {subtitle}
    </EmptyStateSubtitle>
  </EmptyStateContainer>
);
